import { MazeedApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new MazeedApiService(ApiClientFactory());

export function MazeedApiServiceFactory(): typeof service {
  return service;
}
